export enum ButtonColor {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  CUSTOM = "custom",
}

export enum ButtonSize {
  SM = "sm",
  MD = "md",
  LG = "lg",
}

export enum Theme {
  GEORGIA = "georgia-theme",
  UK = "uk-theme",
  UZ = "uz-theme",
}

export enum ThemeCountry {
  GEORGIA = "ge",
  UK = "uk",
  UZ = "uz",
}

export enum Shop {
  EBAY = "ebay.com",
  HM = "hm.com",
  LEVIS = "levis.com",
  AMAZON = "amazon.com",
  SIXPM = "6pm.com",
  APPLE = "apple.com",
  ETSY = "etsy.com",
  TEMU = "temu.com",
  WAIKIKI = "waikiki.com",
  ZARA = "zara.com",
  UNIVERSAL = "universal",
}

export enum Country {
  UKRAINE = 1,
  USA = 2,
  TURKEY = 3,
  GEORGIA = 4,
  // UZBEKISTAN = 5,
  CHINA_AIR = 6,
  CHINA_LAND = 7,
  GREECE = 8,
  GERMANY = 9,
  INDIA = 10,
  SPAIN = 11,
  POLAND = 12,
  ENGLAND = 13,
}

export enum ParcelCategoryUZ {
  TOYS_AND_CHILDREN_GOODS = 21,
  SPORTS_AND_LEISURE_GOODS = 2,
  BOOKS_MOVIES_MUSIC_AND_GAMES = 12,
  HEALTH_AND_BEAUTY = 7,
  MIXED_PRODUCTS = 8,
  HOME_AND_GARDEN = 9,
  AUTOMOTIVE_INDUSTRY = 10,
  COMPUTERS_AND_OFFICE_SUPPLIES = 214,
  OTHER = 3,
  CLOTHING = 45,
  SHOES = 46,
  ACCESSORIES = 47,
  DO_NOT_USE_MOBILE_PHONE = 170,
  GLASSES = 200,
  E_BOOKS = 209,
  WATCHES = 208,
  BAGS = 206,
  HEADPHONES = 207,
  COSTUME_JEWELRY = 205,
  COMPUTER_PARTS = 204,
  MOVIES_MUSIC = 203,
  GAMES = 202,
  BOOKS = 201,
  POWERBANKS_AND_CHARGING_STATIONS = 180,
  TECH_AND_ELECTRONICS = 6,
  AUTO_MOTO_AND_INDUSTRIAL_GOODS = 11,
  COSMETICS_AND_HEALTH_PRODUCTS = 16,
  MOBILE_PHONES = 168,
  HOME_GOODS = 17,
  // new items
  SAFETY_AND_PROTECTION = 211,
  FOR_BABIES = 212,
  OFFICE_AND_STATIONERY = 213,
  FURNITURE = 215,
  MEDICATIONS_AND_MEDICAL_INSTRUMENTS = 216,
  MUSIC_INSTRUMENTS = 217,
  LIGHTING = 218,
  FOOD_PRODUCTS = 219,
  CONSTRUCTION_AND_RENOVATION = 220,
  JEWELRY_AND_ACCESSORIES = 222,
  TECH_AND_COMPUTERS = 15,
}

export enum ParcelCategoryGe {
  VARIOUS_GOODS = 3,
  GADGETS = 6,
  AUTO_MOTO_GOODS = 11,
  COSMETICS = 16,
  HOUSEHOLD_GARDENING = 17,
  GOODS_FOR_KIDS = 21,
  CLOTH = 45,
  SHOES = 46,
  BOOKS = 190,
  GAMES = 200,
  MOVIES_MUSIC = 210,
  COMPUTER_PARTS = 220,
  IMITATION_JEWELRY = 230,
  GLASSES = 242,
  BAGS = 244,
  HEADPHONES = 246,
  WATCH = 248,
  CELL_PHONES = 168,
  ELECTRONIC_BOOKS = 250,
  COMPUTER_TECHINCS = 260,
  PHONE_PARTS = 270,
  IPADS_TABLETS = 280,
  VITAMINS_AND_DIETARY_SUPPLEMENTS = 290,
}

export enum ParcelCategoryUK {
  VARIOUS_GOODS = 3,
  GADGETS = 6,
  REPAIR_PARTS = 11,
  COSMETICS = 16,
  HOUSEHOLD_GARDENING = 17,
  GOODS_FOR_KIDS = 21,
  CLOTH = 45,
  SHOES = 46,
  CELL_PHONES = 168,
  POWER_BANKS_AND_CHARGERS = 180,
  BOOKS = 190,
  GAMES = 200,
  MOVIES_MUSIC = 210,
  COMPUTER_PARTS = 220,
  IMITATION_JEWELRY = 230,
  GLASSES = 242,
  BAGS = 244,
  HEADPHONES = 246,
  WATCH = 248,
  ELECTRONIC_BOOKS = 250,
  COMPUTER_TECHNICS = 260,
  PHONE_PARTS = 270,
  IPADS_TABLETS = 280,
  VITAMINS_AND_DIETARY_SUPPLEMENTS = 290,
  STARLINK = 310,
}

export enum TransportationMode {
  AIR = 1,
  GROUND = 3,
  SEA = 2,
  ECONOMY = 4,
}

export enum PlaceOfDelivery {
  OFFICE = "office",
  COURIER = "courier_services",
}

export enum ModalType {
  ADD = "add",
  EDIT = "edit",
  VIEW = "view",
  DELETE = "delete",
}

export enum Color {
  RED = "red",
  BLUE = "blue",
  GREEN = "green",
  BLACK = "black",
}

export enum LoyalityStatus {
  BRONZE = "bronze",
  SILVER = "silver",
  GOLD = "gold",
  PLATINIUM = "platinium",
}

export enum ParcelStatus {
  // received
  COMMON_STATUS_STATUS_WAITING_TO_RECEIVE = "COMMON_STATUS_STATUS_WAITING_TO_RECEIVE",
  COMMON_STATUS_RECEIVED_AT_THE_INSTOCK = "COMMON_STATUS_RECEIVED_AT_THE_INSTOCK",
  COMMON_STATUS_PROCESSED_AT_THE_INSTOCK = "COMMON_STATUS_PROCESSED_AT_THE_INSTOCK",
  COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY = "COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY",
  COMMON_STATUS_SHIPPED_FROM_FCOUNTRY = "COMMON_STATUS_SHIPPED_FROM_FCOUNTRY",
  COMMON_STATUS_RECEIVED_OUTSTOCK = "COMMON_STATUS_RECEIVED_OUTSTOCK",
  COMMON_STATUS_READY_FOR_PICKUP = "COMMON_STATUS_READY_FOR_PICKUP",
  COMMON_STATUS_DELIVERY_REQUEST = "COMMON_STATUS_DELIVERY_REQUEST",
  COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER = "COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER",
  COMMON_STATUS_DELIVERED = "COMMON_STATUS_DELIVERED",
}

export enum FilterType {
  COUNTRY = "country",
  CATEGORY = "category",
  TRANSPORT = "transport",
  STATUS = "status",
  REGISTRATION_DATE = "registrationDate",
  SEND_DATE = "sendDate",
  DELIVERY_DATE = "deliveryDate",
}

export enum TransactionType {
  WITHDRAW = 1,
  REFILL = 2,
}

export enum AddressType {
  MAIN = "main",
  DELIVERY = "delivery",
  CUSTOM = "custom",
  DEPARTMENT = "department",
}

export enum PasswordStrength {
  NONE = "",
  WEAK = "validations_password_weak",
  MEDIUM = "validations_password_medium",
  STRONG = "validations_password_strong",
}

export enum PaymentProvider {
  PAYME = "payme",
  CLICK = "click",
  BOG = "GeorgianBank",
}

export enum InterfaceLanguage {
  EN = "en",
  RU = "ru",
  UZ = "uz",
  UK = "uk",
  KA = "ka",
}

export enum TransportationType {
  AIR = "air",
  GROUND = "ground",
  SEA = "sea",
  ECONOMY = "economy",
  EXPRESS = "express",
}

export enum TransportationPriceType {
  AIR = "airPriceUsd",
  SEA = "seaPriceUsd",
  SEA_ECONOMY = "seaPriceEconomyUsd",
}
